/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: yinwenxuan yinwenxuan@vip56.cn
 * @LastEditTime: 2025-07-22 09:39:26
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbShopAccount {
    /**
     * WEB端 用户登录
     */
    export var GetWebUsersLogin = (body: any): Promise<any> => {
        return Get(`/api/TbShopAccount/GetWebUsersLogin`, body);
    };
    /**
     * 查询员工列表
     */
    export var GetTbShopAccountList = (body: any): Promise<any> => {
        return Get(`/api/TbShopAccount/GetTbShopAccountList`, body);
    };
    /**
     * 新增员工信息
     */
    export var PostTbShopAccount = (body: any): Promise<any> => {
        return Post(`/api/TbShopAccount/PostTbShopAccount`, body);
    };
    /**
     * 查询员工信息
     */
    export var GetTbShopAccountById = (body: any): Promise<any> => {
        return Get(`/api/TbShopAccount/GetTbShopAccountById`, body);
    };
    /**
     * 删除员工
     */
    export var DeleteTbShopAccount = (id: any): Promise<any> => {
        return Delete(`/api/TbShopAccount/DeleteTbShopAccount?id=${id}`, {});
    };
    /**
     * 查询员工下拉列表
     */
    export var GetTbShopAccountDropList = (body: any): Promise<any> => {
        return Get(`/api/TbShopAccount/GetTbShopAccountDropList`, body);
    };
    /**
     * 修改员工信息
     */
    export var UpdateTbShopAccount = (body: any): Promise<any> => {
        return Put(`/api/TbShopAccount/UpdateTbShopAccount`, body);
    };
    /**
     * 获取版本号
     */
     export var GetVersion = (body: any): Promise<any> => {
        return Get(`/api/TbShopAccount/GetVersion`, body);
    };
    /**
     * 添加备用金
     */
    export var AddTbImprest = (body: any): Promise<any> => {
        return Post(`/api/TbImprest/AddTbImprest`, body);
    };
}



// WEBPACK FOOTER //
// ./src/http/api_TbShopAccount.ts